<template>
  <div class="field">
    <p class="control has-icons-left has-icons-right">
      <input
        class="input"
        type="email"
        placeholder="Search for an artist..."
        @input="setSearchTerm($event)"
        @keyup.enter="enterClicked()"
      />
      <span class="icon is-small is-left">
        <vue-fontawesome icon="search" />
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "AlbumsSerchInput",

  methods: {
    enterClicked() {
      if (this.$route.name !== "home") {
        this.$router.push({ name: "home" });
      }
    },
    setSearchTerm(event) {
      this.$store.commit("setSearchTerm", event.target.value);
    }
  }
};
</script>
